
import api from './api.js'
import {
  weixin
} from '@beastshop/browser'
const MESSAGE = '未知服务器错误'
const JS_API_LIST = [
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'hideMenuItems'
]
function noop() {}
const DEFAULT_OPTIONS = {
  title: '野兽派 - The Beast Shop',
  content : 'default content',
  group: '', // 需要分享朋友圈的文案，如果该字段缺省则分享朋友圈为title
  link: 'https://m.thebeastshop.com',
  image: 'https://img.thebeastshop.com/images/mcatlog/banner/share.png',
  success: noop,
  cancel: noop
}

let config  = null

module.exports = function(options, isShare = true){
  if(!weixin()){
    return
  }
  let _option = Object.assign(DEFAULT_OPTIONS, options)
  // wx.checkJsApi({
  //   jsApiList: JS_API_LIST,
  //   success: function(res) {
      _getConfig()
      .then(({data}) => {
        config = data
        // alert(JSON.stringify(data))
        _config(data)
        _ready(_option, isShare)
      })
  //   }
  // })
  // _checkJsApi()
  // .then((_apis) => {
  //   _getConfig()
  //   .then(({data}) => {
  //     _config(data)
  //     _ready(options)
  //   })
  // })
}

// function _checkJsApi(){
//   return new Promise((resolve, reject) => {
//     wx.checkJsApi({
//       jsApiList: JS_API_LIST,
//       success: function(res) {
//         let _result = res.checkResult
//         let weixinApiList = []
//         Object.keys(_result).forEach((name) => {
//           if(_result[name]){
//             weixinApiList.push(name)
//           }
//         })
//         if(weixinApiList.length > 0) {
//           resolve(weixinApiList)
//         }else{
//           reject()
//         }
//       }
//     })
//   })
// }
function _getConfig(){
  if(config){
    return Promise.resolve({
      data: config
    })
  }
  let data = {url: location.href}
  // let postData = JSON.stringify(data)
  return api.signature(data)
}

function _config({
  appId,
  timestamp,
  nonceStr,
  signature
}){
  wx.config({
      // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature,// 必填，签名，见附录1
      jsApiList: JS_API_LIST // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
}

function _ready({
  title,
  content,
  link,
  image,
  group,
  success,
  cancel
}, isShare){
  wx.ready(function(){
    if(!isShare){
      wx.hideMenuItems({
        menuList: [
          'menuItem:share:appMessage',
          'menuItem:share:timeline',
          'menuItem:share:qq',
          'menuItem:share:facebook',
          'menuItem:share:QZone',
          'menuItem:favorite',
          'menuItem:share:weiboApp',
          'menuItem:copyUrl',
          'menuItem:share:email',
          'menuItem:share:brand',
          'menuItem:openWithSafari',
          'menuItem:originPage'
        ]
      })
      return
    }
    wx.onMenuShareTimeline({  // 分享到朋友圈
        title: group || title, // 分享标题
        link: link, // 分享链接
        imgUrl: image, // 分享图标
        success: () => {
          success('Timeline')
        },
        cancel: () => {
          cancel('Timeline')
        }
    });

    wx.onMenuShareAppMessage({ // 分享给朋友
        title: title, // 分享标题
        desc: content, // 分享描述
        link: link, // 分享链接
        imgUrl: image, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: () => {
          success('WeChat')
        },
        cancel: () => {
          cancel('WeChat')
        }
    });
  })
}



// WEBPACK FOOTER //
// ./static/wechat-share/index.js